import styled from "styled-components";
import {
  FileCertificate,
  FileIcon,
  HoldingHandsIcon,
  LeafIcon,
  UserCheckIcon,
  UserIcon,
  UserRemoveIcon,
  UsersIcon,
} from "../../assets";

// Normalize function
const normalize = (status = "") => status.trim().toLowerCase();

// Color and icon maps using normalized keys
const STATUS_COLORS = {
  won: "rgba(18, 124, 78, 0.1)",
  "verbally committed": "rgba(244, 186, 52, 0.1)",
  "proposal sent": "rgba(244, 186, 52, 0.1)",
  lost: "rgba(240, 70, 63, 0.1)",
  "lead identified": "rgba(89, 84, 222, 0.1)",
  opportunity: "rgba(89, 84, 222, 0.1)",
  all: "rgba(100, 116, 139, 0.1)",
};

const ICONS = {
  won: UserCheckIcon,
  lost: UserRemoveIcon,
  "proposal sent": FileIcon,
  "verbally committed": HoldingHandsIcon,
  "lead identified": UserIcon,
  opportunity: LeafIcon,
  all: UsersIcon,
};

const Frame1428 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 48px;
  min-height: 48px;
  border-radius: 999px;
  background: ${(props) => {
    const key = normalize(props.status);
    const color = STATUS_COLORS[key] || "#eee";
    return `linear-gradient(-90deg, ${color}, ${color})`;
  }};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

const StatusBadge = ({ status, showCustomWon = false }) => {
  const key = normalize(status);
  let icon;
  if (key === "won" && showCustomWon) {
    icon = FileCertificate; // Your special icon when showCustomWon is true
  } else {
    icon = ICONS[key] || UsersIcon;
  }
  return (
    <Frame1428 status={status}>
      <img src={icon} alt={status} width={20} height={20} />
    </Frame1428>
  );
};

export default StatusBadge;
